export interface SpotlightModel {
    id: number,
    codeMetric: number | null,
    name: string,
    weight: number,
    eopWeight: number
}

export const spotlightModelInitial: SpotlightModel = {
    id: 0,
    codeMetric: null,
    name: '',
    weight: 0,
    eopWeight: 0
};